import React from 'react'
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import { ImageUrl } from '../../../../../Helpers/request'

const DiscoverMore = () => {
  return (
    <div className='natursection text-center' style={{background: `url(${ImageUrl}theme/tokyo/home-banner-natural.png) no-repeat center`}}>
        <Container>
            <h2>Loose Diamonds</h2>
            <p>All diamonds vary in size, color, clarity, cut, and carat weight. We only deal in certified and graded loose diamonds of the highest quality.</p>
            <Link className="main_button" to="/diamonds">Discover More</Link>
        </Container>
    </div>
  )
}

export default DiscoverMore